import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

interface OnboardingLaunchPromptModalProps {
  open: boolean;
  onClose: () => void;
  onGoToNurturingPlanGenerator: () => void;
}

const OnboardingLaunchPromptModal: React.FC<OnboardingLaunchPromptModalProps> = ({
  open,
  onClose,
  onGoToNurturingPlanGenerator,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        borderRadius: 1,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        overflow: 'hidden',
        minWidth: 420,
        maxWidth: 480,
      },
    }}
  >
    <DialogTitle
      sx={{
        p: 2.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
      }}
    >
      <Typography variant="h6">Launch Readiness complete</Typography>
      <IconButton onClick={onClose} size="small" sx={{ color: 'text.secondary' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>

    <DialogContent sx={{ p: 3 }}>
      <Typography variant="body1" color="text.primary" sx={{ lineHeight: 1.6 }}>
        Great work — Launch Readiness is finished. Either go to{' '}
        <strong>Nurturing Plan Generator</strong> and use <strong>Launch</strong> when you
        are ready, or click the <strong>Launch Dealer</strong> button now visible in the
        header to activate this dealership for nurturing.
      </Typography>
    </DialogContent>

    <DialogActions
      sx={{
        px: 3,
        py: 2,
        borderTop: '1px solid rgba(0, 0, 0, 0.05)',
        gap: 1,
      }}
    >
      <Button onClick={onClose} variant="outlined" sx={{ textTransform: 'none' }}>
        Got it
      </Button>
      <Button
        onClick={onGoToNurturingPlanGenerator}
        variant="contained"
        color="primary"
        startIcon={<RocketLaunchIcon />}
        sx={{ textTransform: 'none' }}
      >
        Go to Nurturing Plan Generator
      </Button>
    </DialogActions>
  </Dialog>
);

export default OnboardingLaunchPromptModal;
